module.exports = __webpack_public_path__ + "img/authorization.118c0cc5.svg";